export default __webpack_public_path__ + "static/media/114-users.d79b69ae.svg";